// import React, { useEffect, useState, useCallback } from "react";
// import { apiGET } from "../../utilities/apiHelpers";

// const PaymentSummary = ({ item, globalConfig }) => {
//     const [serviceability, setServiceability] = useState(null);
//     const [loading, setLoading] = useState(false);

//     // 1. Extract currency safely
//     const currency = globalConfig?.currencyData?.symbol || "₹";
//     const currentZip = item?.selectedAddress?.zip;

//     const handleCheckService = useCallback(async (zipCode) => {
//         const pincodeToCheck = zipCode || currentZip;

//         if (!pincodeToCheck) {
//             setServiceability(null);
//             return;
//         }

//         setLoading(true);
//         try {
//             const url = `/v1/shipment/serviceability/${pincodeToCheck}`;
//             const response = await apiGET(url);
//             const apiResponse = response.data;

//             if (apiResponse?.success === true && apiResponse?.data?.status === true) {
//                 setServiceability({
//                     status: true,
//                     remark: apiResponse.data.remark || "Service Available",
//                     details: apiResponse.data.details
//                 });
//             } else {
//                 setServiceability({
//                     status: false,
//                     remark: apiResponse?.data?.remark || apiResponse?.message || "Service unavailable at this location"
//                 });
//             }
//         } catch (error) {
//             console.error("⚠️ Fetch Error:", error);
//             setServiceability({ 
//                 status: false, 
//                 remark: "Connection Error: Could not reach service" 
//             });
//         } finally {
//             setLoading(false);
//         }
//     }, [currentZip]); // Added currentZip as dependency

//     // 2. Trigger check only when currentZip changes
//     useEffect(() => {
//         if (currentZip) {
//             handleCheckService(currentZip);
//         } else {
//             setServiceability(null);
//         }
//     }, [currentZip, handleCheckService]);

//     return (
//         <div className="bg-white shadow-md rounded-lg p-6">
//             <h3 className="text-lg font-semibold text-gray-800 border-b pb-2">Payment Summary</h3>
            
//             <div className="mt-4 space-y-2">
//                 <p className="flex justify-between text-gray-600">
//                     <span>Cart Amount</span> 
//                     <span>{currency}{item?.cartAmount}</span>
//                 </p>
//                 <p className="flex justify-between text-gray-600">
//                     <span>Packaging Charges</span> 
//                     <span>+ {currency}{globalConfig?.packagingCharges}</span>
//                 </p>
//                 <p className="flex justify-between text-gray-600">
//                     <span>Delivery Charges</span> 
//                     <span>+ {currency}{globalConfig?.deliveryCharges}</span>
//                 </p>
//                 <p className="flex justify-between text-[#14967F] border-t pt-2 mt-4 font-bold text-lg">
//                     <span>Total to pay</span> 
//                     <span>{currency}{item?.totalCartAmount}</span>
//                 </p>
//             </div>

//             {/* Serviceability Section */}
//             <div className="mt-6">
//   {/* Header */}
//   <div className="flex justify-between items-center mb-2">
//     <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">
//       Shipping to: {currentZip || "No Zip Provided"}
//     </span>
//     <button
//       onClick={() => handleCheckService(currentZip)}
//       disabled={loading || !currentZip}
//       className="text-xs text-blue-600 font-bold hover:underline disabled:text-gray-300"
//     >
//       {loading ? "Verifying..." : "Check Again"}
//     </button>
//   </div>

//   {currentZip ? (
//     <div
//       className={`p-4 rounded-lg border-2 transition-all ${
//         loading
//           ? "bg-gray-50 border-gray-100"
//           : serviceability?.status
//           ? "bg-green-50 border-green-200"
//           : "bg-red-50 border-red-200"
//       }`}
//     >
//       {/* Main Status */}
//       {loading ? (
//         <div className="flex items-center gap-2 text-gray-500 text-sm">
//           <div className="w-4 h-4 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
//           <span>Checking Availability...</span>
//         </div>
//       ) : (
//         <div className="space-y-3">
//           <h3 className="text-sm font-bold text-gray-700 uppercase tracking-wide border-b pb-1">
//             Serviceability
//           </h3>

//           {/* Status */}
//           <p
//             className={`text-sm font-bold flex items-center gap-2 ${
//               serviceability?.status ? "text-green-700" : "text-red-600"
//             }`}
//           >
//             {serviceability?.status} {serviceability?.remark}
//           </p>

//           {/* Details Boxes */}
//           {serviceability?.status && serviceability.details && (
//             <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-2 mt-2">
//               {/* City */}
//               <div className="p-2 rounded border border-gray-200 bg-white text-gray-700 text-xs font-medium">
//                 <b>City:</b> {serviceability.details.city}
//               </div>

//               {/* State */}
//               <div className="p-2 rounded border border-gray-200 bg-white text-gray-700 text-xs font-medium">
//                 <b>State:</b> {serviceability.details.state}
//               </div>

//               {/* COD */}
//               <div className="p-2 rounded border border-gray-200 bg-white text-gray-700 text-xs font-medium">
//                 <b>Cash on Delivery:</b>{" "}
//                 {serviceability.details.cod
//                   ? `Up to ${currency}${serviceability.details.max_cod_amount}`
//                   : "Prepaid Only"}
//               </div>

//               {/* Return */}
//               <div className="p-2 rounded border border-gray-200 bg-white text-gray-700 text-xs font-medium">
//                 <b>Return:</b>{" "}
//                 {serviceability.details.reverse_pickup ||
//                 serviceability.details.reverse_drop
//                   ? "Available"
//                   : "Not Available"}
//               </div>
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   ) : (
//     <div className="p-3 bg-amber-50 border border-amber-100 rounded text-amber-700 text-xs">
//       ⚠️ Please select a delivery address to verify shipping.
//     </div>
//   )}
// </div>

//         </div>
//     );
// };

// export default PaymentSummary;  


import React, { useEffect, useState, useCallback } from "react";
import { apiGET } from "../../utilities/apiHelpers";

const PaymentSummary = ({ item, globalConfig, setCanPay }) => {
  const [serviceability, setServiceability] = useState(null);
  const [loading, setLoading] = useState(false);

  // 1. Extract currency safely
  const currency = globalConfig?.currencyData?.symbol || "₹";
  const currentZip = item?.selectedAddress?.zip;

  const handleCheckService = useCallback(async (zipCode) => {
    const pincodeToCheck = zipCode || currentZip;

    if (!pincodeToCheck) {
      setServiceability(null);
      if (setCanPay) setCanPay(false); // Lock if no zip
      return;
    }

    setLoading(true);
    try {
      const url = `/v1/shipment/serviceability/${pincodeToCheck}`;
      const response = await apiGET(url);
      const apiResponse = response.data;

      // --- MOVED LOGIC INSIDE THE FUNCTION ---
      const isAvailable = apiResponse?.success === true && apiResponse?.data?.status === true;
      
      // Tell the parent component the result immediately
      if (setCanPay) setCanPay(isAvailable);

      if (isAvailable) {
        setServiceability({
          status: true,
          remark: apiResponse.data.remark || "Service Available",
          details: apiResponse.data.details
        });
      } else {
        setServiceability({
          status: false,
          remark: apiResponse?.data?.remark || apiResponse?.message || "Service unavailable at this location"
        });
      }
      // ---------------------------------------
      
    } catch (error) {
      console.error("⚠️ Fetch Error:", error);
      if (setCanPay) setCanPay(false); // Lock on error
      setServiceability({
        status: false,
        remark: "Connection Error: Could not reach service"
      });
    } finally {
      setLoading(false);
    }
  }, [currentZip, setCanPay]);

  // 2. Trigger check only when currentZip changes
  useEffect(() => {
    if (currentZip) {
      handleCheckService(currentZip);
    } else {
      setServiceability(null);
      if (setCanPay) setCanPay(false);
    }
  }, [currentZip, handleCheckService, setCanPay]);

  return (
    <div className="bg-white shadow-md rounded-lg p-6">
      <h3 className="text-lg font-semibold text-gray-800 border-b pb-2">Payment Summary</h3>

      <div className="mt-4 space-y-2">
        <p className="flex justify-between text-gray-600">
          <span>Cart Amount</span>
          <span>{currency}{item?.cartAmount}</span>
        </p>
        <p className="flex justify-between text-gray-600">
          <span>Packaging Charges</span>
          <span>+ {currency}{globalConfig?.packagingCharges}</span>
        </p>
        <p className="flex justify-between text-gray-600">
          <span>Delivery Charges</span>
          <span>+ {currency}{globalConfig?.deliveryCharges}</span>
        </p>
        <p className="flex justify-between text-[#14967F] border-t pt-2 mt-4 font-bold text-lg">
          <span>Total to pay</span>
          <span>{currency}{item?.totalCartAmount}</span>
        </p>
      </div>

      <div className="mt-6">
        <div className="flex justify-between items-center mb-2">
          <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">
            Shipping to: {currentZip || "No Zip Provided"}
          </span>
          <button
            onClick={() => handleCheckService(currentZip)}
            disabled={loading || !currentZip}
            className="text-xs text-blue-600 font-bold hover:underline disabled:text-gray-300"
          >
            {loading ? "Verifying..." : "Check Again"}
          </button>
        </div>

        {currentZip ? (
          <div
            className={`p-4 rounded-lg border-2 transition-all ${loading
                ? "bg-gray-50 border-gray-100"
                : serviceability?.status
                  ? "bg-green-50 border-green-200"
                  : "bg-red-50 border-red-200"
              }`}
          >
            {loading ? (
              <div className="flex items-center gap-2 text-gray-500 text-sm">
                <div className="w-4 h-4 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
                <span>Checking Availability...</span>
              </div>
            ) : (
              <div className="space-y-3">
                <h3 className="text-sm font-bold text-gray-700 uppercase tracking-wide border-b pb-1">
                  Serviceability
                </h3>
                <p
                  className={`text-sm font-bold flex items-center gap-2 ${serviceability?.status ? "text-green-700" : "text-red-600"
                    }`}
                >
                  {serviceability?.status ? "✓" : "✕"} {serviceability?.remark}
                </p>

                {serviceability?.status && serviceability.details && (
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-2 mt-2">
                    <div className="p-2 rounded border border-gray-200 bg-white text-gray-700 text-xs font-medium">
                      <b>City:</b> {serviceability.details.city}
                    </div>
                    <div className="p-2 rounded border border-gray-200 bg-white text-gray-700 text-xs font-medium">
                      <b>State:</b> {serviceability.details.state}
                    </div>
                    <div className="p-2 rounded border border-gray-200 bg-white text-gray-700 text-xs font-medium">
                      <b>Cash on Delivery:</b>{" "}
                      {serviceability.details.cod
                        ? `Up to ${currency}${serviceability.details.max_cod_amount}`
                        : "Prepaid Only"}
                    </div>
                    <div className="p-2 rounded border border-gray-200 bg-white text-gray-700 text-xs font-medium">
                      <b>Return:</b>{" "}
                      {serviceability.details.reverse_pickup || serviceability.details.reverse_drop
                        ? "Available"
                        : "Not Available"}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        ) : (
          <div className="p-3 bg-amber-50 border border-amber-100 rounded text-amber-700 text-xs">
            ⚠️ Please select a delivery address to verify shipping.
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentSummary;